"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowMigrateButton = void 0;
const react_1 = __importStar(require("react"));
const file_saver_1 = require("file-saver");
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const core_ui_1 = require("@sierralabs/core-ui");
const WorkflowValidateDialog_1 = __importDefault(require("../dialogs/WorkflowValidateDialog"));
const useWorkflowValidator_1 = require("../hooks/useWorkflowValidator");
const WorkflowMigrateButton = props => {
    const { workflow, onImport } = props;
    const fileInputRef = (0, react_1.useRef)(null);
    const [action, setAction] = (0, react_1.useState)();
    const [errorMessage, setErrorMessage] = (0, react_1.useState)();
    const [importConfig, setImportConfig] = (0, react_1.useState)();
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const validator = (0, useWorkflowValidator_1.useWorkflowValidator)({
        taskType: workflow === null || workflow === void 0 ? void 0 : workflow.taskType,
        taskTypeId: workflow === null || workflow === void 0 ? void 0 : workflow.taskTypeId
    });
    const { config } = workflow;
    const actionLabel = action === 'import' ? 'Import' : 'Export';
    const handleFiles = (files) => __awaiter(void 0, void 0, void 0, function* () {
        if (!files || files.length === 0) {
            return;
        }
        const result = yield (0, core_ui_1.readTextFile)(files[0], value => {
            const config = JSON.parse(value || '');
            // validate file
            if (!config || !config.name || !Array.isArray(config.states)) {
                throw new Error();
            }
            return config;
        });
        if (result) {
            const { value, error } = result;
            !error && setAction('import');
            setImportConfig(value);
            setErrorMessage(error);
            validator.validate(value);
        }
    });
    const importWorkflow = () => {
        if (importConfig) {
            onImport === null || onImport === void 0 ? void 0 : onImport(importConfig);
            setImportConfig(undefined);
        }
    };
    const exportWorkflow = () => {
        if (config) {
            const blob = new Blob([JSON.stringify(config, undefined, 2)], {
                type: 'application/json'
            });
            (0, file_saver_1.saveAs)(blob, `${workflow.name} - Workflow.json`);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', endIcon: react_1.default.createElement(icons_1.ArrowDropDown, null), onClick: event => setAnchorEl(event.currentTarget) }, "Migrate"),
        react_1.default.createElement(core_1.Menu, { id: 'workflow-migrate-menu', keepMounted: true, open: !!anchorEl, anchorEl: anchorEl, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, onClose: () => setAnchorEl(null) },
            react_1.default.createElement(core_1.MenuItem, { onClick: () => {
                    var _a;
                    setAnchorEl(null);
                    (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
                } }, "Import Workflow"),
            react_1.default.createElement(core_1.MenuItem, { disabled: !config, onClick: () => {
                    setAction('export');
                    setAnchorEl(null);
                    validator.validate(config);
                } }, "Export Workflow")),
        react_1.default.createElement("input", { hidden: true, type: 'file', accept: 'application/json', ref: fileInputRef, onChange: event => {
                handleFiles(event.target.files);
                // clear input field
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            } }),
        react_1.default.createElement(WorkflowValidateDialog_1.default, { open: !!action, result: validator.result, validator: validator.validator, title: `Confirm ${actionLabel} Workflow`, confirmLabel: `Confirm and ${actionLabel}`, onCancel: () => {
                setAction(undefined);
                action === 'import' && setImportConfig(undefined);
            }, onConfirm: () => {
                setAction(undefined);
                action === 'import' ? importWorkflow() : exportWorkflow();
            } }, !validator.result.isValidating && (react_1.default.createElement(react_1.default.Fragment, null,
            action === 'import' && (react_1.default.createElement(core_1.Box, { mb: 1 },
                react_1.default.createElement(core_1.Typography, { variant: 'body2' }, "Are you sure you want to import this workflow? This will overwrite the existing workflow."))),
            react_1.default.createElement(core_1.Box, { mb: 1 },
                react_1.default.createElement(core_1.Typography, { variant: 'overline' }, "Workflow Validation Check Results"))))),
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'error', open: !!errorMessage, onClose: () => setErrorMessage(undefined) }, errorMessage)));
};
exports.WorkflowMigrateButton = WorkflowMigrateButton;
exports.default = exports.WorkflowMigrateButton;
//# sourceMappingURL=WorkflowMigrateButton.js.map